<script>

    import { userStore } from '../stores'

    import ModalContainer from '../$components/modal.container.svelte'

    import FixedpricesComponent from './component.fixedprices.svelte'
    import FixedpriceComponent from './component.fixedprice.svelte'
    import FixedpriceUpdateComponent from './component.update.svelte'
    import FixedpriceUploadComponent from './component.upload.svelte'
    import FixedpriceCreateComponent from './component.create.svelte'

    userStore.set(null)

    import TitleHero from '../$components/title.hero.svelte'
    import View from '../$layouts/view.layout.svelte'

</script>

<View>
    <div>
        <TitleHero title="Precios fijos" subtitle="Consulta y gestión de precios fijos" />
        <FixedpricesComponent showUsers />
    </div>
</View>

<ModalContainer id="fixedprice_modal" title="Precio fijo" >
    <FixedpriceComponent />
</ModalContainer>

<ModalContainer id="fixedprice_create_modal" title="Registrar fixedprice" >
    <FixedpriceCreateComponent />
</ModalContainer>

<ModalContainer id="fixedprice_update_modal" title="Actualizar fixedprice" >
    <FixedpriceUpdateComponent />
</ModalContainer>

<ModalContainer id="fixedprice_upload_modal" title="Cargar fixedprice" >
    <FixedpriceUploadComponent />
</ModalContainer>